import { clockTimePattern } from './regex';

const hoursOnly = /^(\d{1,2})$/;
const digitsOnly = /^(\d{1,2})(\d{2})$/;
const withColon = /^(\d{1,2}):(\d{0,2})$/;

/**
 * Completes a time of day the user typed in short: `16` → `16:00`, `9` → `09:00`,
 * `930` → `09:30`, `16:3` → `16:30`.
 *
 * A single minute digit is read as tens, since `16:3` is half past rather than three past.
 * TextFieldTime reads `1:3` as `1:03` instead; a duration is not a time of day, so the two
 * are not meant to agree.
 *
 * Input that does not complete to a valid time between 00:00 and 23:59 is returned trimmed
 * but otherwise as typed, so the field can show it as wrong instead of hiding it.
 */
export const completeClockTime = (input: string): string => {
  const trimmed = input.trim();
  const match = trimmed.match(hoursOnly) ?? trimmed.match(digitsOnly) ?? trimmed.match(withColon);

  if (!match) {
    return trimmed;
  }

  const [, hours, minutes = ''] = match;
  const completed = `${hours.padStart(2, '0')}:${minutes.padEnd(2, '0')}`;

  return clockTimePattern.test(completed) ? completed : trimmed;
};
